export function isOrganizationAccount(user) {
  return user?.accountKind === "organization";
}

export function getUserDisplayName(user) {
  if (!user) return "";
  if (user.displayName) return user.displayName;
  if (isOrganizationAccount(user)) {
    return user.organizationName || "";
  }
  return [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
}

export function getUserContactPerson(user) {
  if (!user) return "";
  if (user.contactPerson) return user.contactPerson;
  if (isOrganizationAccount(user)) {
    return user.contactPersonName || "";
  }
  return getUserDisplayName(user);
}

export function getPartnerDisplayName(partner) {
  if (!partner) return "";
  if (partner.displayName) return partner.displayName;
  if (partner.accountKind === "organization") {
    return partner.organizationName || partner.display_name || "";
  }
  return [partner.firstName || partner.first_name, partner.lastName || partner.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
}
